import { useMemo } from 'react';
import { BOOLEAN_STRING } from '@sib/config';
import { useTranslation } from '@sib/i18n';

export const useBooleanOptions = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t('yes'), value: BOOLEAN_STRING.True },
      { label: t('no'), value: BOOLEAN_STRING.False },
    ],
    [t]
  );
};
